<template>
  <div :class="componentClassName">
    <section class="t-entry-sidebar__sidebar">
      <div class="t-entry-sidebar__sidebar-holder">
        <div class="t-entry-sidebar__composite-logo">
          <div class="t-entry-sidebar__logo-composite">
            <a id="composite" :href="compositeUrl" target="_blank">
              <img src="@/images/composite_yoko_rgb_color.svg" alt="NTT Communications" width="320" />
            </a>
          </div>
        </div>
        <div class="t-entry-sidebar__logo">
          <div class="t-entry-sidebar__logo-cotoha">
            <img src="@/images/cotoha-call-center-logo-horizontal.svg" alt="COTOHA Call Center" width="250" />
          </div>
        </div>
        <a-heading :heading="sidebarHeading" tag="h1" subheading-tag="span" :subheading="sidebarSubHeading" />
        <m-progress :steps="sidebarList" :current="sidebarCurrent" class="t-entry-sidebar__progress" />
      </div>
    </section>
    <section class="t-entry-sidebar__body">
      <div class="t-entry-sidebar__content">
        <slot name="alert"></slot>
        <a-heading
          :heading="heading"
          tag="h1"
          subheading-tag="span"
          :subheading="subHeading"
          variant="border"
          class="t-entry-sidebar__heading"
        />
        <slot>Content</slot>
      </div>
      <o-global-footer v-if="footer" class="t-entry-sidebar__footer" />
    </section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

import AHeading from '@/components/atoms/heading';
import MProgress from '@/components/molecules/progress';
import OGlobalFooter from '@/components/organisms/global-footer';

import Simplebar from 'simplebar';

export default {
  name: 't-default-entry-sidebar',
  components: {
    AHeading,
    MProgress,
    OGlobalFooter,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    sidebarHeading: {
      type: String,
      default: null,
    },
    sidebarSubHeading: {
      type: String,
      default: null,
    },
    sidebarList: {
      type: Array,
      default: new Array(0),
    },
    sidebarCurrent: {
      type: [String, Number],
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    footer: {
      type: Boolean,
      default: true,
    },
    compositeUrl: {
      type: String,
      default: 'https://www.ntt.com',
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-entry-sidebar', this.$slots.alert ? 'with-alert' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    new Simplebar(this.$el.querySelector('.t-entry-sidebar__sidebar-holder'));
  },
};
</script>
